// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n[data-v-48703eea]:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\n.scroll-container[data-v-48703eea]{\n  -ms-scroll-snap-type:x mandatory;\n      scroll-snap-type:x mandatory\n}\n.snap-center[data-v-48703eea]{\n  scroll-snap-align:center\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
